<template>
  <div>
    <!-- 盒子 -->
    <b-row>
      <b-tabs pills card :vertical="iswin ? true : false">
        <b-tab title="研究项目" active><Project></Project></b-tab>
        <b-tab title="论文发表"><Paper></Paper></b-tab>
      </b-tabs>
    </b-row>
    <b-row v-show="isMo">
      <b-col>
        <!-- <el-menu :default-active="defaultId" class="el-menu-vertical-demo" text-color="#fff" background-color="#002d71" active-text-color="#FBC52C" @select="handleSelect" mode="horizontal">
          <template v-for="item in items">
            <template>
              <el-menu-item :index="item.id + ''" :key="item.id">
                <span slot="title" class="menuTxT">{{ item.name }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
        <el-card>
          <div v-html="content"></div>
        </el-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Project from "./Project.vue";
import Paper from "./Paper.vue";
// import request from "../utils/request";
export default {
  name: "Achievement",
  data() {
    return {
      iswin: true,
      inMo: false,
    };
  },
  components: {
    Project,
    Paper,
  },
  created() {},
  mounted() {
    this.checkWindowWidth(); // 初始化时检查窗口大小
    window.addEventListener("resize", this.checkWindowWidth); // 监听窗口大小变化
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkWindowWidth); // 在组件销毁前移除事件监听
  },
  methods: {
    checkWindowWidth() {
      if (window.innerWidth > 1000) {
        this.iswin = true;
        this.isMo = false;
      } else {
        this.iswin = false;
        this.isMo = true;
      }
    },
    handleSelect(key) {},
    getContent(id) {},
  },
};
</script>

<style scoped>
@media (max-width: 1000px) {
  .menuTxT {
    font-size: medium;
    font-weight: bold;
  }
}

@media (min-width: 770px) and (max-width: 1205px) {
  .MenuTxT {
    font-size: large;
  }
}

@media (min-width: 1205px) {
  .MenuTxT {
    font-size: large;
  }
}
.tab_b:hover {
  background-color: #032252;
}
div/deep/ .nav-pills {
  --bs-nav-pills-border-radius: 0;
  --bs-nav-pills-link-active-color: #fbc52c;
  --bs-nav-pills-link-active-bg: #002d71;
}
/* .nav-pills:hover {
  background-color: #032252;
} */
div/deep/.nav {
  --bs-nav-link-color: #fff;
  font-size: larger;
  --bs-nav-link-hover-color: #fbc52c;
  background-color: #002d71;
}
div/deep/.nav-item:hover {
  background-color: #032252;
}
div/deep/ .col-auto {
  margin: auto;
  margin-top: 0;
  width: 250px;
}
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}
.sidebar > ul {
  height: 100%;
}
</style>
